import React from "react";
import { EmptyItem } from "rhombus-react";

export default function YoutubeUrlTile({ onClick }){
	return (
		<div className="youtube-url-click-wrapper" onClick={onClick}>
			<EmptyItem
				className="youtube-url"
				icon="youtubeVast"
				title="YouTube URL"
				message=" "
			/>
		</div>
	);
}

YoutubeUrlTile.displayName = "YoutubeUrlTile";
